/* Brief touch feedback for the homepage's existing collection links. */
(() => {
  let pressedCard;
  const mobile = window.matchMedia('(max-width: 749px)');
  const clearPress = () => {
    pressedCard?.classList.remove('is-pressed');
    pressedCard = undefined;
  };

  document.addEventListener('pointerdown', (event) => {
    clearPress();
    if (!mobile.matches || event.pointerType === 'mouse' || !event.isPrimary) return;
    pressedCard = event.target.closest('.ww-category-card__link[href]');
    pressedCard?.classList.add('is-pressed');
  }, { passive: true });

  for (const event of ['pointerup', 'pointercancel', 'scroll']) {
    document.addEventListener(event, clearPress, { passive: true, capture: true });
  }
  for (const event of ['blur', 'pagehide', 'pageshow']) {
    window.addEventListener(event, clearPress);
  }
})();
